import { Vehicle, VehicleLocation, VehicleType, CollectionDevice } from 'server'
import { icons } from '../../../../data/icons'
import { getTimeDifferenceInMinutes } from '../../../../utils/time'
import { defaultVehicleFilter } from '../../../../utils/filtering'

// Create an object with 29 different colors
const colors = [
  'red',
  'blue',
  'green',
  'purple',
  'orange',
  'pink',
  'brown',
  'black',
  'yellow',
  'grey',
  'cyan',
  'magenta',
  'lime',
  'teal',
  'indigo',
  'violet',
  'fuchsia',
  'gold',
  'silver',
  'crimson',
  'navy',
  'maroon',
  'olive',
  'limegreen',
  'aqua',
  'lightcoral',
  'darkorange',
  'darkseagreen',
  'darkslategray'
]

export const getVehicleIcon = (
  vehicle: Vehicle,
  vehicleLocation: VehicleLocation,
  vehicleType: VehicleType
): {
  width: string
  height: string
  src: string
  name: string
  alt: string
  zIndex: number
} => {
  const isAir = vehicle.vehicle_category_id === 2

  let icon = icons[vehicleType?.key]
  if (!icon) {
    // default icon
    icon = icons['ambulance']
  }
  if (isAir) {
    icon = icons['helicopter']
  }
  const difference = getTimeDifferenceInMinutes(vehicleLocation?.update_received)
  const old = difference > 15
  const scale = 5
  const scaledWidth = icon.width / scale
  const scaledHeight = icon.height / scale
  const name = getVehicleName(vehicle)
  const zIndex = isAir ? 2 : 1

  return {
    width: `${scaledWidth}px`,
    height: `${scaledHeight}px`,
    src: old ? icon.greyUrl : icon.url,
    name,
    alt: name,
    zIndex: zIndex
  }
}

export const getVehicleDotColor = (vehicleType: VehicleType) => {
  return colors[vehicleType.id]
}

export const getVehicleName = (vehicle: Vehicle) => {
  return vehicle.unit_name || vehicle.name
}


export const filterByLocalStorage = (
  vehicleLocations: VehicleLocation[],
  vehicleMap: Map<number, Vehicle>,
  selectedCollections: number[],
  collectionDevices: CollectionDevice[],
  texasMask: boolean,
  ground: boolean,
  air: boolean,
  ambus: boolean
) => {

  return vehicleLocations.filter((vehicleLocation: VehicleLocation) => {

    const filtered = !!selectedCollections.length
    const vehicleIds = collectionDevices
      ? collectionDevices?.map((collectionDevice: any) => collectionDevice.vehicle_id)
      : []

    const vehicle = vehicleMap.get(vehicleLocation.vehicle_id)
    if (!vehicle) return false
    if (filtered && vehicleIds) {
      if (!vehicleIds.includes(vehicle.vehicle_id)) {
        return false
      }
    }
    const groundUnit = vehicle.vehicle_category_id === 1
    const ambusUnit = vehicle.vehicle_type_id === 11
    const airUnit = vehicle.vehicle_category_id === 2
    if (!defaultVehicleFilter(vehicle, vehicleLocation, texasMask)) {
      return false
    }

    if (groundUnit) {
      if (!ground && !ambusUnit) {
        return false
      }
      if (ambusUnit && !ambus) {
        return false
      }
    }
    if (airUnit && !air) {
      return false
    }

    return true
  })

}

export const showDecimalAsPercentage = (decimal: number) => {
  return (decimal * 100).toFixed(0) + '%'
}
